import React from 'react';

const IconFinland = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.2 38.4" {...props}>
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#fff"
          d="M3.03 0h49.13c1.67 0 3.03 1.36 3.03 3.03v32.33c0 1.66-1.36 3.02-3.02 3.03H3.02C1.36 38.4 0 37.03 0 35.37V3.03C0 1.36 1.36 0 3.03 0z"
        />
        <path fill="#002f6c" d="M0 15.36h55.2v7.68H0z" />
        <path fill="#002f6c" d="M15.36 0h7.68v38.4h-7.68z" />
      </g>
    </svg>
  );
};

export default IconFinland;
